export const transition = {
  slow: ".5s",
  reg: ".4s",
  fast: ".2s",
};
